export default "__VITE_ASSET__DQ2bwuj2__"